import { AccountCurrency } from '@/billing/constants/common';

export class B2BModel {
  id!: number;
  title!: string;
  account!: {
    balance: string;
    overdraft: string;
    currency: AccountCurrency;
  };
}

export class B2B extends B2BModel {
  constructor({ id, title }: B2BModel) {
    super();

    this.id = id;
    this.title = title;
  }
}
